import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) => {
  return data.map(
    ({ fieldName, placeholder, name, formType, validation, className, options, imageDimension, usedFileType }) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      options: options,
      imageDimension: imageDimension,
    })
  );
};

export const fields: any = {
  centralizedSingleCabinLuggagePolicyPageContent: mapFields(
    drilldownData["centralizedSingleCabinLuggagePolicyPageContent"]
  ),
  centralizedSingleCabinLuggagePolicyPageImage: mapFields(
    drilldownData["centralizedSingleCabinLuggagePolicyPageImage"]
  ),
  centralizedGuidelinesForCheckedinLuggagePageContent: mapFields(
    drilldownData["centralizedGuidelinesForCheckedinLuggagePageContent"]
  ),
  centralizedGuidelinesForCheckedinLuggagePageImage: mapFields(
    drilldownData["centralizedGuidelinesForCheckedinLuggagePageImage"]
  ),
  centralizedLagsLiquidItemImage: mapFields(drilldownData["centralizedLagsLiquidItemImage"]),
  centralizedLagsPageContent: mapFields(drilldownData["centralizedLagsPageContent"]),
  centralizedRestrictedItemsCheckedInCabinRestrictionsContent: mapFields(
    drilldownData["centralizedRestrictedItemsCheckedInCabinRestrictionsContent"]
  ),
  centralizedRestrictedItemsCheckedInCabinRestrictionsImage: mapFields(
    drilldownData["centralizedRestrictedItemsCheckedInCabinRestrictionsImage"]
  ),
  centralizedRestrictedItemsCabinOnlyRestrictionsContent: mapFields(
    drilldownData["centralizedRestrictedItemsCabinOnlyRestrictionsContent"]
  ),
  centralizedRestrictedItemsCabinOnlyRestrictionsImage: mapFields(
    drilldownData["centralizedRestrictedItemsCabinOnlyRestrictionsImage"]
  ),
  centralizedLagsDisclaimerContent: mapFields(drilldownData["centralizedLagsDisclaimerContent"]),
  centralizedLagsGuidelinesContent: mapFields(drilldownData["centralizedLagsGuidelinesContent"]),
  centralizedLagsSteps: mapFields(drilldownData["centralizedLagsSteps"]),
};
